import WhatsAppButton from './WhatsAppButton';

export default function QuickActions() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-4">
      <WhatsAppButton />
    </div>
  );
}
